/**
 * params
 * @scanSite
 * @nextSite
 * @nextSites
*/
export const VolumesQuery = params => {
  return [
    {
      // title: '运力情况-下一站',
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['nextSite', 'nextProvinceArea'],
      andFilters: [
        {key: 'scanType', value: '分拨装车'},
        {key: 'isDestinationCenter', value: '否'},
        {key: 'scanSite', value: params.scanSite},
      ],
    },
    [
      {
        // title: '预测出发  // 预计发中转总计',
        simpleGranularity: 'all',
        dataSource: 'actual_forecast_result',
        dimensions: ['nextSite', 'nextProvinceArea'],
        andFilters: [
          {key: 'scanType', value: '分拨发车'},
          {key: 'isDestinationCenter', value: '否'},
          {key: 'scanSite', value: params.scanSite},
        ],
        inFilters: [
          {key: 'nextSite', value: params.nextSites},
        ]
      },
      {
        // title: '网点预测发中转',
        simpleGranularity: 'all',
        dataSource: 'actual_forecast_result',
        dimensions: ['nextSite', 'nextProvinceArea'],
        andFilters: [
          {key: 'scanType', value: '分拨发车'},
          {key: 'isOriginCenter', value: '是'},
          {key: 'isDestinationCenter', value: '否'},
          {key: 'scanSite', value: params.scanSite},
        ],
        inFilters: [
          {key: 'nextSite', value: params.nextSites},
        ]
      },
      {
        // title: '分拨预测发中转',
        simpleGranularity: 'all',
        dataSource: 'actual_forecast_result',
        dimensions: ['nextSite', 'nextProvinceArea'],
        andFilters: [
          {key: 'scanType', value: '分拨发车'},
          {key: 'isOriginCenter', value: '否'},
          {key: 'isDestinationCenter', value: '否'},
          {key: 'scanSite', value: params.scanSite},
        ],
        inFilters: [
          {key: 'nextSite', value: params.nextSites},
        ]
      },
      {
        // title: '库存',
        simpleGranularity: 'all',
        dataSource: 'actual_load_unload_result',
        dimensions: ['nextSite', 'nextProvinceArea'],
        andFilters: [
          {key: 'scanSite', value: params.scanSite},
        ],
        inFilters: [
          {key: 'scanType', value: ['分拨卸车', '分拨装车']},
          {key: 'nextSite', value: params.nextSites},
        ]
      },
    ]
  ]
}